import React from 'react';
import PropTypes from 'prop-types';
import { Stack, Button } from '@mui/material';
import ProtectedComponent from '../../../components/protected/ProtectedComponent';
import Iconify from '../../../components/iconify';

const AssetHeader = ({ onCreateClick, onDashboardClick, onBulkUploadClick }) => (
  <Stack direction="row" alignItems="center" justifyContent="flex-end" spacing={1.5} mb={2.5}>
    <Button
      type="button"
      variant="outlined"
      color="inherit"
      startIcon={<Iconify icon="eva:pie-chart-2-fill" />}
      onClick={onDashboardClick}
    >
      Dashboard
    </Button>
    <ProtectedComponent permission="CREATE_USER">
      <Button
        type="button"
        variant="outlined"
        startIcon={<Iconify icon="solar:import-bold" />}
        onClick={onBulkUploadClick}
      >
        Import / Bulk Upload
      </Button>
    </ProtectedComponent>
    <ProtectedComponent permission="CREATE_USER">
      <Button type="button" variant="contained" startIcon={<Iconify icon="eva:plus-fill" />} onClick={onCreateClick}>
        New Asset
      </Button>
    </ProtectedComponent>
  </Stack>
);

AssetHeader.propTypes = {
  onCreateClick: PropTypes.func,
  onDashboardClick: PropTypes.func,
  onBulkUploadClick: PropTypes.func,
};

export default AssetHeader;
